module.exports = __webpack_public_path__ + "img/35 igual.0d7d0b63.jpg";